export default __webpack_public_path__ + "static/media/ppt.01a286bd.svg";